import React from 'react';
import { withStyles } from '@material-ui/core/styles';


//drop down field
import MenuItem from 'material-ui/MenuItem';
import { ValidatorForm,SelectValidator } from 'react-material-ui-form-validator';

import Button from '@material-ui/core/Button';

//API Gateway
import {API} from "aws-amplify";

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
});

class LanguageSelect extends React.Component {
  state = {
    languages:[],
    language:''

  };

    //Make GET request to get the list of language
    async componentDidMount() {
  
        try {

          const languages =await this.getLanguage();
          this.setState({ languages });

        } catch (e) {
          alert(e);
        }
      
        this.setState({ submitted: false });
      }
     // make call to API to get language for dropdown list

      getLanguage() {
        return API.get("language", "/language");
      }

  // language Dropdown Menu change
  handleLanguageFieldChange = (event, index, language) => 
  {
      this.setState({language});
      var languageName = language;

      this.props.onChange(languageName);
  }

  selectionRenderer = (languages) => {
    switch (languages.length) {
      case 0:
        return '';
      case 1:
        return languages;
      default:
        return languages;
    }
  }

  menuItems(languages) {
    return languages.map((l) => (
      <MenuItem
        key={l.language}
        insetChildren={true}
        checked={this.state.languages.indexOf(l.language) > -1}
        value={l.language}
        primaryText={l.language}
      />
    ));
  }

  reset(event) {

    this.setState({  
      language:''
  });

  this.props.onChange('','');  

  };
  render() {

    return (
      <div>

        <ValidatorForm
                ref="form"
                onSubmit={this.handleLanguageFieldChange}

            >            
             <SelectValidator
                  floatingLabelText="Language"
                  name= "language"
                  autoWidth={true}
                  value={this.state.language}
                  onChange={this.handleLanguageFieldChange}
                  selectionRenderer={this.selectionRenderer}
                  
                >
                  {this.menuItems(this.state.languages.sort((a, b) => (a.language < b.language ? -1 : 1)))}
                </SelectValidator>
                <Button size="small" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:10, marginBottom:20}}>
                    Reset
                </Button>
        </ValidatorForm>
      </div>
    );
  }
}



export default withStyles(styles)(LanguageSelect);